// Utils
import { getFullDomain, getProtocol } from './subdomain-helpers';


/**
 * Generates a restaurant URL
 * @param {string} restaurantSlug - The restaurant slug
 * @param {boolean} useSubdomain - Whether to use subdomain format (default: true)
 * @returns {string|null} The restaurant URL
 */
const generateRestaurantUrl = (restaurantSlug, useSubdomain = true) => {
  if (!restaurantSlug) return null;

  const baseUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  const isProductionEnvironment = process.env.VERCEL_ENV === 'production';

  const shouldUseSubdomain = useSubdomain && baseUrl && isProductionEnvironment;

  // If subdomain is disabled or not configured, use path-based URL
  if (!shouldUseSubdomain) {
    return `/restaurant/${restaurantSlug}`;
  }

  // Extract protocol and full domain (with port) using helper functions
  const protocol = getProtocol();
  const fullDomain = getFullDomain();

  return `${protocol}://${restaurantSlug}.${fullDomain}`;
};

export default generateRestaurantUrl;
